export default __webpack_public_path__ + "static/media/antp_Nom012_2y3marzo_BannerRegistro.b292600b.jpg";